import { Route, useLocation, matchPath } from 'react-router';
import { Page } from '@roc/feature-app-core';
import { InspectionsDashboard } from '../inspectionsDashboard';
import { InspectionReport } from '../inspectionReport';

const INSPECTIONS_HOME_BASE_PATH = 'inspections';
const INSPECTION_BASE_PATH = ':inspectionId';

export function getInspectionRoutesConfig(basePath: string, baseUrl: string) {
  return {
    inspections: {
      dashboard: {
        path: `${basePath}/${INSPECTIONS_HOME_BASE_PATH}/dashboard`,
        url: `${baseUrl}/${INSPECTIONS_HOME_BASE_PATH}/dashboard`,
        documentTitle: 'Inspections Dashboard',
      },
      report: (inspectionId?: string) => ({
        path: `${basePath}/${INSPECTIONS_HOME_BASE_PATH}/${INSPECTION_BASE_PATH}/report`,
        url: `${baseUrl}/${INSPECTIONS_HOME_BASE_PATH}/${inspectionId}/report`,
        documentTitle: 'Inspection Report',
      }),
    },
  };
}

export function getInspectionRoutes(basePath: string, baseUrl: string) {
  const config = getInspectionRoutesConfig(basePath, baseUrl);
  const location = useLocation();
  const match = matchPath<{ inspectionId: string }>(location.pathname, {
    path: config.inspections.report().path,
    exact: true
  });
  const inspectionId = +match?.params.inspectionId;

  return {
    dashboard: (
      <Route exact path={config.inspections.dashboard.path}>
        <Page routeDefinition={config.inspections.dashboard}>
          <InspectionsDashboard />
        </Page>
      </Route>
    ),
    report: (
      <Route exact path={config.inspections.report().path}>
        <Page routeDefinition={config.inspections.report()}>
          <InspectionReport inspectionId={inspectionId} />
        </Page>
      </Route>
    ),
  };
}
